import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
// import HomeContainer from "../Container/HomeContainer";
import HomeContainer from "../Container/HomeContainer2"
import VocationalResumeContents from "./VocationalResumeContents"
// import TeacherResume from "./TeacherResume";
// import axios from "axios";
// import { useArray, useForceUpdate } from "../../Hook";
// import { PORT } from "../../config";
import Spinner from "../../Components/Spinner/Spinner"

//Yuan:redux
import { connect } from "react-redux"
// import { store } from "../../redux/store";
import { createStructuredSelector } from "reselect"
//Yuan-selector
import { selectUserDetails } from "../../redux/homePage/homePage.selectors"
import { updateToRoot } from "../../redux/homePage/homePage.actions"
import Tour from "reactour";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { API } from "../../API"

const VocationalResume = ({ user, updateToRoot }) => {
  let [showTour, setShowTour] = useState(
    JSON.parse(window.localStorage.getItem('firstTime')) || false,
  )

  useEffect(() => {
    API.getUserSafeData().then(res => {
      updateToRoot(res.data?.user)
    })
  }, [])

  const tourSteps = [
    {
      content:
        (<React.Fragment>
            WAIT! We advise that you prepare your documents for uploading before completing the qualifications section
            of your Resume. Watch
            <b style={{color: "DodgerBlue", cursor: "pointer"}}
               onClick={() => window.open("https://drive.google.com/file/d/1f8JcC5u2RhEVAYvdi_BxVJRmQfYaz_He/view?usp=drivesdk", "_blank")}> this
              video </b>
            for instructions on reducing the file size of your documents.
          </React.Fragment>
        )
    },
  ]

  const closeTour = () => {
    setShowTour(false)
    window.localStorage.setItem('firstTime', 'false')
  }

  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={true}
        isShowWhereby={false}
        footer={null}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={false}
        tabVetResumeActive={true}
      >
        <div
          className="guide-tour-icon"
        >
          <HoverIcon
            icon="info"
            circular
            inverted
            className="search-help-icon"
            onClick={() => setShowTour(true)}
            text="Click for guide"
          />
        </div>
        <Tour
          showCloseButton={false}
          accentColor="#79cbca"
          className="tourContent"
          steps={tourSteps}
          isOpen={showTour}
          onRequestClose={closeTour}
        >
          <div className="tour-dot" onClick={closeTour} />
        </Tour>
        <VocationalResumeContents
          user={user}
          isViewAsTeacher={true}
        />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) =>
    dispatch(updateToRoot(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(VocationalResume)
